/**
 * Section ordering & labels used by the "Wording" page. The raw key list
 * lives in `./widget-keys.generated.ts`, which is produced by
 * `pnpm --filter @babackapp/return-widget scan:keys` — that script writes
 * the widget copy and its sibling copy here. Do not edit the generated
 * file by hand; rerun the script when widget keys change.
 */
import type { WidgetKeySection } from "./widget-keys.generated";

export type { WidgetKeyDescriptor, WidgetKeySection } from "./widget-keys.generated";
export { WIDGET_KEYS } from "./widget-keys.generated";

export const SECTION_ORDER: WidgetKeySection[] = [
  "home",
  "articles",
  "reason",
  "resolution",
  "confirmation",
  "gift-card",
  "common",
];

export const SECTION_LABELS: Record<WidgetKeySection, string> = {
  home: "Accueil",
  articles: "Articles",
  reason: "Raison",
  resolution: "Résolution",
  confirmation: "Confirmation",
  "gift-card": "Carte cadeau",
  common: "Commun",
};
